import { parseCookies } from './parseCookies';
export const LK_COOKIE = 'show_new_features';
export function isLkEnabled(cookieString = '') {
    // return true
    if (!cookieString) {
        return false;
    }
    return LK_COOKIE in parseCookies(cookieString);
}
